import React from "react";
import { Divider, Form } from "antd";
import moment from "moment";
import Customer from "../../../common/FormSections/Customer";
import Phone from "../../../common/FormSections/Phone";
import Email from "../../../common/FormSections/Email";
import ServiceType from "../../../common/FormSections/ServiceType";
import Monetization from "../../../common/FormSections/Monetization";
import RequestNumber from "../common/sections/RequestNumber";
import { CarrierComment } from "../common/sections/CarrierComment";
import Routes from "../../../common/FormSections/Routes";
import Performer from "../../../common/FormSections/Performer";
import AdditionalServices from "../../../common/FormSections/AdditionalServices";
import PriceFinal from "../../../common/FormSections/Price/PriceFinal";
import PriceFinalNDS from "../../../common/FormSections/Price/PriceFinalNDS";
import TotalPrice from "../../../common/FormSections/Price/TotalPrice";
import PriceNoNds from "../../../common/FormSections/Price/PriceNoNds";
import OfferPaymentType from "../../../common/FormSections/OfferPaymentType";
import SurchargePayment from "../../../common/FormSections/SurchargePayment";
import SurchargePaymentDate from "../../../common/FormSections/SurchargePaymentDate";
import RefundFreighterDate from "../../../common/FormSections/RefundFreighterDate";
import OfferDocuments from "../../../common/FormSections/OfferDocuments";
import Dispatcher from "../../../common/FormSections/Dispatcher";
import VehicleTypes from "../../../common/FormSections/VehicleTypes";
import Vehicle from "../../../common/FormSections/Vehicle";
import Drivers from "../../../common/FormSections/Drivers";
import MonetizationTemplates from "../../../common/FormSections/MonetizationTemplates";
import OfferEndDateTime from "../../../common/FormSections/OfferEndDateTime";
import { loginFailure } from "../../../../Authorization/redux/actions/Login";

class OfferInfo extends React.Component {
  state = {
    showAllFields: false,
    monetizationFieldsDisabled: false,
    monetizationSectionPass: false
  };
  handleClickShowAllFields = () => {
    this.setState(state => ({ showAllFields: !state.showAllFields }));
  };

  checkCompleted = name => {
    return this.props.formProgress.some(
      f => f.name === name && f.completed === true
    );
  };

  toggleMonetizationFields = value => {
    this.setState({
      monetizationFieldsDisabled: value
    });
  };

  passMonetizationSection = () => {
    this.setState(
      {
        monetizationSectionPass: !this.state.monetizationSectionPass
      },
      () => {
        this.props.form.setFieldsValue({
          monetizationIsPassed: this.state.monetizationSectionPass
        });
      }
    );
  };

  render() {
    const { form } = this.props;
    const { monetizationFieldsDisabled } = this.state;
    const customerFilled = this.checkCompleted("customer");
    const serviceTypeFilled = this.checkCompleted("serviceType");
    const routeProgramFilled = this.checkCompleted("routeProgram");
    const performerFilled = this.checkCompleted("performer");
    // const monetizationFilled = this.checkCompleted("monetization");
    const priceFilled = this.checkCompleted("price");
    const surcharge = this.checkCompleted("surcharge");
    // Переменные для разработки
    // const customerFilled = true;
    // const serviceTypeFilled = true;
    // const routeProgramFilled = true;
    // const performerFilled = true;
    // const monetizationFilled = true;
    // const priceFilled = true;
    // const surcharge = true;
    const totalPrice = form.getFieldValue("totalPrice");
    const sumUndestributedPrice = (
      totalPrice,
      paySum = 0,
      predPaySum = 0,
      postPaySum = 0
    ) => {
      if (totalPrice) {
        return totalPrice - predPaySum - paySum - postPaySum;
      } else {
        return null;
      }
    };
    const predPaySum =
      form.getFieldValue("predPay") &&
      form.getFieldValue("predPay").length > 0 &&
      form
        .getFieldValue("predPay")
        .map(item =>
          form.getFieldValue("predPayPrice" + item)
            ? parseInt(form.getFieldValue("predPayPrice" + item))
            : 0
        )
        .reduce((acc, curr) => acc + curr);
    const paySum = form.getFieldValue("payPrice");
    const postPaySum =
      form.getFieldValue("postPay") &&
      form.getFieldValue("postPay").length > 0 &&
      form
        .getFieldValue("postPay")
        .map(item =>
          form.getFieldValue("postPayPrice" + item)
            ? parseInt(form.getFieldValue("postPayPrice" + item))
            : 0
        )
        .reduce((acc, curr) => acc + curr);
    return (
      <div className="card-info">
        <Form layout="inline">
          <RequestNumber form={form} disabled={true} />
          <Customer form={form} disabled={true} />
          <Phone form={form} disabled={true} />
          <Email form={form} disabled={true} />
          <ServiceType form={form} disabled={true} />
          {serviceTypeFilled && (
            <>
              <Divider />
              <Routes form={form} disabled={false} />
            </>
          )}
          {routeProgramFilled && (
            <>
              <Divider />
              <Performer form={form} disabled={false} />
              <Dispatcher form={form} disabled={false} />
              <VehicleTypes form={form} disabled={false} />
              <Vehicle form={form} disabled={false} />
              <Drivers form={form} disabled={false} />
              <OfferEndDateTime form={form} disabled={false} />
            </>
          )}
          {performerFilled && (
            <>
              <Divider />
              <MonetizationTemplates
                form={form}
                disabled={false}
                toggleMonetizationFields={this.toggleMonetizationFields}
                passMonetizationSection={this.passMonetizationSection}
                monetizationSectionPass={this.state.monetizationSectionPass}
              />
              <Monetization
                form={form}
                disabled={!this.state.monetizationFieldsDisabled}
                disabledKp1urc={false}
                monetizationSectionPass={this.state.monetizationSectionPass}
              />
              <Divider />
              <PriceNoNds form={form} disabled={false} />
              <AdditionalServices form={form} disabled={false} />
              <PriceFinal form={form} disabled={true} />
              <PriceFinalNDS form={form} disabled={true} />
              <TotalPrice form={form} disabled={true} />
            </>
          )}
          {priceFilled && (
            <>
              <Divider />
              <OfferPaymentType
                form={form}
                disabled={false}
                sumUndestributedPrice={sumUndestributedPrice(
                  totalPrice,
                  paySum,
                  predPaySum,
                  postPaySum
                )}
              />
            </>
          )}
          {sumUndestributedPrice(totalPrice, paySum, predPaySum, postPaySum) ===
            0 && (
            <>
              <Divider />
              <SurchargePayment form={form} disabled={false} />
              <SurchargePaymentDate form={form} disabled={false} />
              <RefundFreighterDate form={form} disabled={false} />
            </>
          )}
          {surcharge && (
            <>
              <Divider />
              <OfferDocuments form={form} disabled={false} />
              <Divider />
              <CarrierComment form={form} disabled={false} />
            </>
          )}
        </Form>
      </div>
    );
  }
}

class OfferInfoData extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {}
    };
  }

  componentDidMount() {
    this.initEditing();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    // if (this.props.request !== prevProps.request) {
    //   this.initEditing();
    // }
  }

  getValueByFieldName(name, val) {
    if (name.includes("Date")) {
      return (val && moment(val)) || null;
    } else {
      return val;
    }
  }

  saveFormRef = formRef => {
    if (formRef && formRef.props && formRef.props.form) {
      this.formRef = formRef.props.form;
    } else {
      this.formRef = null;
    }
    this.props.setForm(this.props.name, this.formRef);
  };

  handleFieldsChange = values => {
    // Если есть серверные ошибки, и это поле изменилось, то удаляем ошибку из store
    if (this.props.createErrors) {
      Object.keys(values).forEach(name => {
        if (
          this.props.createErrors &&
          this.props.createErrors.data &&
          this.props.createErrors.data[name]
        ) {
          if (values[name].errors) {
            delete values[name].errors;
          }
          this.props.clearError(name);
        }
      });
    }

    this.setState(
      state => {
        return {
          data: {
            ...state.data,
            ...values
          }
        };
      },
      () => {
        this.changeValues(this.state.data);
      }
    );
  };

  validateField = nameField => {
    let result =
      this.formRef &&
      this.formRef.isFieldTouched(nameField) &&
      this.formRef.getFieldError(nameField);
    return {
      status: result ? "error" : "",
      help: result || ""
    };
  };

  initEditing = () => {
    let newData = {};
    const data = this.props.request;
    if (data) {
      Object.keys(data).forEach(item => {
        // необходимость прокинуть данные из заявки в форму

        if (item === "requestId") {
          newData["requestId"] = Form.createFormField({
            value: data[item]
          });
        }

        if (item === "number") {
          newData["requestNumber"] = Form.createFormField({
            value: data[item]
          });
        }

        if (item === "serviceTypeId") {
          newData["serviceType"] = Form.createFormField({
            value: data[item].serviceTypeKey
          });
        }

        if (item === "serviceAdditional") {
          newData["additionalServices"] = Form.createFormField({
            value: data[item].map(service => service.serviceAdditionalKey)
          });
        }

        if (item === "arrivalDatetime") {
          newData["arrivalDatetime"] = data[item] && moment(data[item]);
        }

        if (item === "routes") {
          newData["routes"] = Form.createFormField({
            value: data[item]
          });

          data[item].forEach((route, index) => {
            newData["routeDuration" + index] = Form.createFormField({
              value: moment(route.duration, "HH:mm")
            });
            newData["route" + index] = Form.createFormField({
              value: route.route
            });
            newData["routeId" + index] = Form.createFormField({
              value: route.routeId
            });
            newData["latitude" + index] = Form.createFormField({
              value: route.latitude
            });
            newData["longitude" + index] = Form.createFormField({
              value: route.longitude
            });
          });
        }

        if (item === "profileId") {
          if (data[item].companyId) {
            newData["companyId"] = Form.createFormField({
              value: data[item].companyId.companyId
            });

            newData["phoneCode"] = Form.createFormField({
              value: data[item].companyId.phoneCode
            });

            newData["phoneNumber"] = Form.createFormField({
              value: data[item].companyId.phone
            });

            newData["email"] = Form.createFormField({
              value: data[item].companyId.email
            });

            newData["subject"] = Form.createFormField({
              value: data[item].companyId.subjectId.subjectKey
            });

            if (data[item].companyId.subjectId.subjectKey === "physical") {
              newData["customer"] = Form.createFormField({
                value:
                  data[item].companyId.lastname +
                  " " +
                  data[item].companyId.name +
                  " " +
                  data[item].companyId.patronymic
              });
              newData["name"] = Form.createFormField({
                value: data[item].companyId.name
              });
              newData["lastname"] = Form.createFormField({
                value: data[item].companyId.lastname
              });
              newData["patronymic"] = Form.createFormField({
                value: data[item].companyId.patronymic
              });
            } else {
              newData["customer"] = Form.createFormField({
                value: data[item].companyId.nameLegal
              });
              newData["nameLegal"] = Form.createFormField({
                value: data[item].companyId.nameLegal
              });
            }
          }
        }

        newData[item] = Form.createFormField({
          value: data[item]
        });
      });
    }
    this.setState({ data: newData }, () => {
      this.props.updateProgress(newData);
    });
  };

  changeValues = values => {
    if (this.formRef) {
      // Обновляем прогресс заполнения
      this.props.updateProgress(values);
    }
  };

  render() {
    const data = this.state.data;
    return (
      <FormOfferInfo
        {...this.props}
        data={data}
        wrappedComponentRef={this.saveFormRef}
        getValueByFieldName={this.getValueByFieldName}
        handleFieldsChange={this.handleFieldsChange}
        validateField={this.validateField}
      />
    );
  }
}

const FormOfferInfo = Form.create({
  name: "formOfferInfo",
  onFieldsChange(props, changedFields) {
    props.handleFieldsChange(changedFields);
  },
  mapPropsToFields(props) {
    let obj = {};

    props.data &&
      Object.keys(props.data).forEach(name => {
        /* todo разобраться с серверыными ошибками*/
        let err = {};

        if (
          props.createErrors &&
          props.createErrors.data &&
          props.createErrors.data[name]
        ) {
          err.errors = [new Error(props.createErrors.data[name])];
        }

        // На этапе маппинга локального стейта я вкорячиваю значения в поля, которые считаются динамически.
        // как-то так. ¯\_(ツ)_/¯
        if (name === "priceNoNds" && props.data[name]) {
          let priceFinal = props.data[name].value;

          const nds =
            props.performers &&
            props.data["performer"] &&
            props.data["performer"].value &&
            props.performers.find(
              item => item.companyId === props.data["performer"].value
            ) &&
            !!props.performers.find(
              item => item.companyId === props.data["performer"].value
            ).nds;

          if (props.data.hasOwnProperty("additionalServices")) {
            props.data["additionalServices"].value &&
              props.data["additionalServices"].value.length &&
              props.data["additionalServices"].value.forEach(item => {
                const servicePrice =
                  props.data["serviceAdditionalPrice" + item] &&
                  props.data["serviceAdditionalPrice" + item].value;
                if (servicePrice) {
                  priceFinal += parseInt(servicePrice);
                }
              });
          }
          const totalPrice = nds
            ? priceFinal + Math.round(priceFinal * 0.2)
            : priceFinal;

          obj["priceFinal"] = Form.createFormField({
            value: props.getValueByFieldName(name, priceFinal)
          });
          obj["priceFinalNDS"] = Form.createFormField({
            value: props.getValueByFieldName(
              name,
              nds ? Math.round(priceFinal * 0.2) : 0
            )
          });
          obj["totalPrice"] = Form.createFormField({
            value: props.getValueByFieldName(name, totalPrice)
          });
        }

        obj[name] = Form.createFormField({
          ...props.data[name],
          ...err,
          value: props.getValueByFieldName(name, props.data[name].value)
        });
      });
    return obj;
  },
  onValuesChange(props, values) {}
})(OfferInfo);

export default OfferInfoData;
